import * as React from "react";
import { useState, useEffect } from "react";
import { InputGroup } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import SvgFlag from "../../Shared/Icons/bootstrap/Flag";
import { Countries, ICountryDefinition } from "../../../shared/Countries";
import { getStrings } from "../Reservation/StringResources";
import { currentLanguage } from "../../S3Booking/Settings";

const strings = getStrings().component.countrySelector;
const lang = currentLanguage;

const emptyCountry = { name: "", code: ""};

export const CountrySelector = (props: { selectedCountry?: ICountryDefinition, required?: boolean, onCountrySelected?: (country: string, countryCode: string) => void }) => {

	const [selected, setSelected] = useState<ICountryDefinition>(props.selectedCountry || emptyCountry);
	const [isInvalid, setIsInvalid] = useState(false);
	const [isValid, setIsValid] = useState(false);

	useEffect(() => {
		if (selected && props.onCountrySelected) {
			props.onCountrySelected(selected.name, selected.code);
		}
	}, [selected]);

	const onBlur = () => {
		if (!props.required)
			return;

		setIsValid(selected !== undefined && selected.code !== "");
		setIsInvalid(selected === undefined || selected.code === "");

		if (props.onCountrySelected)
			props.onCountrySelected(selected?.name, selected?.code);
	};

	const onFocus = () => {
		setIsValid(false);
		setIsInvalid(false);
	};

	return <InputGroup className="country-selector" style={{ flexWrap: "nowrap" }}>
		<InputGroup.Prepend><InputGroup.Text><SvgFlag /></InputGroup.Text></InputGroup.Prepend>
			<Typeahead
				id="typeahead-country"
				labelKey={x => lang === "sv-SE" && x.nameSv ? x.nameSv : x.name }
				filterBy={["name", "nameSv", "code"]}
				onChange={x => setSelected(x.length > 0 ? x[0] : undefined)}
				placeholder={strings.placeholder}
				options={Countries}
				selected={selected ? [selected] : undefined}
				highlightOnlyResult
				onBlur={onBlur}
				onFocus={onFocus}
				isInvalid={isInvalid}
				isValid={isValid}
			/>
			{ selected && <img className="flag" src={`/flags/${selected.code.toLowerCase()}.svg`} alt={selected.name} />}
	</InputGroup>;
};